import React from "react";

const COscarBranding = () => {
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        width: "84px",
        height: "100vh",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <div
        style={{
          transform: "rotate(-90deg) translateX(-54%)",
          transformOrigin: "center",
        }}
      >
        <img
          src="/co_logotype_neon_green.svg"
          alt="Charlie Oscar Logotype"
          style={{
            width: "240px",
            height: "auto",
            display: "block",
          }}
        />
      </div>
      <img
        src="/co_monogram_neon_green.svg"
        alt="Charlie Oscar Logo"
        style={{
          width: "32px",
          height: "auto",
          marginTop: "auto",
          marginBottom: "40px",
        }}
      />
    </div>
  );
};

export default COscarBranding;
